module.exports = __webpack_public_path__ + "img/lacak_pengiriman.f8630731.svg";